import './SignOutButton.css';
import { tDoor } from '../../copy/door';

export interface SignOutButtonProps {
  email: string;
  onSignOut(): void;
}

/**
 * "Sair" no cabeçalho da apuração (ORD-F-153), só com a porta ligada e sessão aberta, fora da TV. O desenho do
 * PollsLink/ReplayLink (pílula de vidro, 12 px), à esquerda do StatusIndicator no computador e na ponta direita no
 * celular, sem deslocar o status do esboço do boot. Apaga a sessão e recarrega: volta a página pública, sem feed.
 */
export function SignOutButton({ email, onSignOut }: SignOutButtonProps) {
  return (
    <button
      type="button"
      class="signout-button"
      data-testid="signout"
      aria-label={tDoor('door.signout.aria', { EMAIL: email })}
      onClick={onSignOut}
    >
      {tDoor('door.signout')}
    </button>
  );
}
